import { baseService, BaseService } from '../base-api';



export class TriggerIndexService {

  constructor(private baseService: BaseService) {}

  fetch() {
    try {
      return this.baseService.genericGetCall("/search/fill/players")
        .then((response: any) => {
          return response;
        });
    } catch (error) {
      return this.baseService.handleError(error);
    }
  }
}

export const triggerIndexService = new TriggerIndexService(baseService);